import { isNull } from 'lodash';
import React from 'react';
import { snapshot } from 'valtio';
import SnackbarMessageWithLink from '../../common/components/SnackbarMessageWithLink';
import { logger } from 'logging-utils';
import { openSnackbar } from '../../snackbar/actions/snackbar-actions';
import jiraService from '../services';
import { setLoadingCreateNewJiraTicket } from '../store-actions/jira-ticket-store-actions';
import JiraTicketStore from '../store/jira-ticket-store';

export const createJiraTicket = async () => {
  setLoadingCreateNewJiraTicket(true);
  try {
    const { jiraTicket, fieldsMetadata } = snapshot(JiraTicketStore);
    const results = await jiraService.createJiraTicket.execute({
      createIssueInput: {
        ...jiraTicket,
        description:
          fieldsMetadata && !fieldsMetadata['description']
            ? null
            : jiraTicket.description,
        summary:
          fieldsMetadata && !fieldsMetadata['summary']
            ? null
            : jiraTicket.summary,
        assignee:
          fieldsMetadata && !fieldsMetadata['assignee']
            ? null
            : jiraTicket.assignee,
        reporter:
          fieldsMetadata && !fieldsMetadata['reporter']
            ? null
            : jiraTicket.reporter,
        aggregations:
          fieldsMetadata && !fieldsMetadata['description']
            ? null
            : jiraTicket.aggregations,
        dynamicFields: jiraTicket.dynamicFields
          ? Object.entries(jiraTicket.dynamicFields).map(([key, value]) => {
              return {
                ...value,
                key,
              };
            })
          : null,
      },
    });

    if (isNull(results)) {
      throw new Error('Create jira ticket error');
    }
    if (results.validationError) {
      openSnackbar(results.validationError, {
        variant: 'info',
      });
      return null;
    }
    if (!results.data) {
      throw new Error('Create jira ticket error');
    }
    const snackbarMessageWithLink = React.createElement(
      SnackbarMessageWithLink,
      {
        message: 'Jira Ticket Created successfully',
        linkTitle: results.data.key,
        linkHref: results.data.self,
      },
    );

    openSnackbar(snackbarMessageWithLink, {
      variant: 'success',
    });

    return results;
  } catch (error) {
    logger.error(error);
    openSnackbar(
      'Error occur while creating this Jira ticket, Troubleshooting root cause is currently in process..',
      {
        variant: 'error',
      },
    );
  } finally {
    setLoadingCreateNewJiraTicket(false);
  }
};
